"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const theme_1 = __importDefault(require("../../styles/theme"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const labelButton_1 = __importDefault(require("../../components/labelButton/labelButton"));
const utils_1 = require("../../utils/utils");
const authSlice_1 = require("./authSlice");
const analytics_1 = require("../../utils/analytics/analytics");
const constants_1 = require("../../constants/constants");
const choices_1 = require("../../utils/choices");
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const openExternalLink_1 = __importDefault(require("../../components/openExternalLink/openExternalLink"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const store_1 = require("../../store");
const input_1 = __importStar(require("../../components/input/input"));
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const CreateAccount = () => {
    const { userEmail, loanEstimate } = (0, store_1.useAppSelector)((state) => {
        return {
            userEmail: state.auth.email,
            loanEstimate: state.auth.loan_estimate,
        };
    });
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [firstName, setFirstName] = (0, react_1.useState)('');
    const [lastName, setLastName] = (0, react_1.useState)('');
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)('');
    const [email, setEmail] = (0, react_1.useState)(userEmail);
    const [password, setPassword] = (0, react_1.useState)('');
    const [confirmPassword, setConfirmPassword] = (0, react_1.useState)('');
    // eslint-disable-next-line
    const [lead, setLead] = (0, react_1.useState)('');
    const { logEventWithExtraProperties, setUser } = (0, analytics_1.useAnalytics)();
    const performCreateAccount = async () => {
        setIsLoading(true);
        let result;
        if (react_native_1.Platform.OS !== 'web') {
            const payload = {
                first_name: firstName.toString(),
                last_name: lastName.toString(),
                phone_number: phoneNumber.toString(),
                email: email.toString(),
                password: password.toString(),
                confirm_password: confirmPassword.toString(),
                app_version: constants_1.APP_VERSION,
                lead,
                firebase_id: await (0, analytics_1.getFirebaseUserTokenId)(),
            };
            dispatch((0, authSlice_1.setLoginOrRegister)());
            result = await dispatch((0, authSlice_1.signUp)(payload));
        }
        else {
            const payload = {
                first_name: firstName.toString(),
                last_name: lastName.toString(),
                phone_number: phoneNumber.toString(),
                email: email.toString(),
                password: password.toString(),
                confirm_password: confirmPassword.toString(),
                lead,
            };
            result = await dispatch((0, authSlice_1.signUp)(payload));
            logEventWithExtraProperties('api_call', {
                name: 'sign_up',
                status: 'submitted',
                location: 'screen_CreateAccount',
                lead: choices_1.leadChoices[lead].label,
            });
        }
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'sign_up',
                status: 'success',
                location: 'screen_CreateAccount',
                lead: choices_1.leadChoices[lead].label,
            });
            setUser();
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'sign_up',
                status: 'failed',
                location: 'screen_CreateAccount',
                lead: choices_1.leadChoices[lead].label,
            });
            setErrors(result.payload);
        }
        setIsLoading(false);
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, backArrow: true, titleText: "Create Account", subTitleText: `You may be eligible for a loan of ${constants_1.NAIRA_SYMBOL}${(0, utils_1.formatNumber)(loanEstimate)}.\nComplete your application so we can review it.`, subTitleColor: theme_1.default.colors.COLOR_PRIMARY, isLoading: isLoading },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "First name", placeholder: "First name", setValue: setFirstName, error: (0, utils_1.getError)('first_name', errors), value: firstName }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Surname", placeholder: "Surname", setValue: setLastName, error: (0, utils_1.getError)('last_name', errors), value: lastName }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PHONE, label: "Phone Number", setValue: setPhoneNumber, error: (0, utils_1.getError)('phone_number', errors), value: phoneNumber }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_EMAIL, label: "Your email", placeholder: "Your email", setValue: setEmail, error: (0, utils_1.getError)('email', errors), value: email }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PASSWORD, label: "Password", placeholder: "Password (at least 8 characters)", setValue: setPassword, error: (0, utils_1.getError)('password', errors), value: password }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PASSWORD, label: "Confirm Password", placeholder: "Confirm Password", setValue: setConfirmPassword, error: (0, utils_1.getError)('confirm_password', errors), value: confirmPassword }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: choices_1.leadChoices, label: "How did you hear about Lendigo?", setValue: setLead, value: lead || '', error: (0, utils_1.getError)('lead', errors) }),
        react_1.default.createElement(labelButton_1.default, { title: "LENDIGO'S TERMS OF SERVICE", textColor: theme_1.default.colors.COLOR_PRIMARY, 
            // WRONG LINK
            onPress: () => (0, openExternalLink_1.default)({
                navigation,
                url: 'https://lendigo.ng/terms-conditions/',
                webViewData: {
                    sourcePage: screenConstants_1.CREATE_ACCOUNT_SCREEN,
                    sourceScreen: 'signUp',
                    name: 'termsAndConditions',
                    title: 'Terms and conditions',
                },
            }), eventName: "signUp_termsAndConditions", textBeforeLink: `By clicking "CONTINUE", you agree with `, textBeforeLinkStyle: { color: colors_1.default.COLOR_GRAY_DARK }, positionStyle: styles_1.default.centerChildHorizontalVertical }),
        react_1.default.createElement(primaryButton_1.default, { disabled: lead === -1, title: "Continue", onPress: performCreateAccount, eventName: "signUp_continue" }),
        react_1.default.createElement(labelButton_1.default, { title: "Login", onPress: () => navigation.replace(screenConstants_1.SIGN_IN_SCREEN), disabled: false, textColor: theme_1.default.colors.COLOR_PRIMARY, eventName: "signUp_login", textBeforeLink: "Already have an account? ", positionStyle: [styles_1.default.centerChildHorizontalVertical, styles_1.default.flexDirectionRow] })));
};
exports.default = CreateAccount;
